import React from 'react';
import { toAbsoluteUrl } from '../../../../utils';

interface Props {
	preview: string;
	isChecked: boolean;
}

export const WidgetLogo = (props: Props): React.ReactElement => {
	const { isChecked, preview } = props;

	return (
		<div className="ui-widget-logo-wrapper">
			{
				isChecked && preview
					? (
						<img
							className="ui-widget-logo-download"
							src={preview}
							alt="logo"
						/>
					) : (
						<img
							className="ui-widget-logo"
							src={toAbsoluteUrl('/media/flex-logo-small.svg')}
							alt="logo"
						/>
					)
			}
		</div>
	);
};
